import { Component, Inject, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { AUC_ICONS_CONFIG_TOKEN, AUC_LINKS_CONFIG_TOKEN, AucIconsConfig, AucLinksConfig } from "@auction-ui/config";
import { AucRootService } from "@auction-ui/root/authn/root.authn.service";
import { AucRouteNames } from "@auction-ui/route.names";
import { AucUserService } from "@auction-ui/services/user.service";
import { MfAuthService, MfBaseComponent, mfDateCurrent, MfModelConfigService, MfTypeInfo } from "@pattonair/material-framework";
import { AUC_ENVIRONMENT } from "../../environments/environment";

const TYPE_INFO: MfTypeInfo = { className: "AucRootUnAuthnComponent" };

@Component({
  selector: "ecom-root-unauthn",
  templateUrl: "./root.unauthn.component.html",
  styleUrls: ["./root.unauthn.component.scss"]
})
export class AucRootUnAuthnComponent extends MfBaseComponent {
  protected _mfDateCurrent = mfDateCurrent;
  protected _isApproved: boolean = true;

  public constructor(
    protected override _injector: Injector,
    protected _router: Router,
    protected _modelConfigService: MfModelConfigService,
    protected _rootService: AucRootService,
    protected _authService: MfAuthService,
    protected _userService: AucUserService,
    @Inject(AUC_ICONS_CONFIG_TOKEN)
    protected _iconsConfig: AucIconsConfig,
    @Inject(AUC_LINKS_CONFIG_TOKEN)
    protected _linksConfig: AucLinksConfig,
  ) {
    super(TYPE_INFO, _injector);
    this._sub(this._userService.isApproved, {
      next: (isApproved) => {
        this._isApproved = isApproved;
        if (isApproved === false) {
          window.location.href = AUC_ENVIRONMENT.eCommerceUrl;
        }
      }
    });
  }

  protected _logIn(): void {
    this._sub(this._authService.runInitialLoginSequence(AucRouteNames.routeAuctionsList));
  }

  protected _goHome(): void {
    this._router.navigate([AucRouteNames.routeHome]);
  }
}
